module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }